import React from 'react'
import { array, object, bool } from 'prop-types'
import { Grid } from '@ycos/component-grid'
import { hasTag } from '@ycos/coremedia-renderer'
import { withTheme, ThemeProvider } from '@ycos/fela'
import SpanContainer from './SpanContainer'
import { getTwoColumnRatios } from './utils'

function TwoColumnWithRatio({ children, item, verticallyCenter, noPaddingTop, noPaddingTopMobile, addPaddingBottom, addPaddingBottomMobile, theme }) {
  const { left, right } = getTwoColumnRatios(item.layoutVariant)
  const alignVertically = verticallyCenter || hasTag(item.tags, 'Columns.VerticallyCenter')

  // reason add below logic is give options to the editor, they can config each children item with no top padding or just config parent item with no top padding 
  const noTopPadding = noPaddingTop || hasTag(item && item.tags, 'Columns.NoTopPadding')
  const noTopPaddingMobile = noPaddingTopMobile || hasTag(item && item.tags, 'Columns.NoTopPaddingMobile')
  const addBottomPadding = addPaddingBottom || hasTag(item && item.tags, 'Columns.AddBottomPadding')
  const addBottomPaddingMobile = addPaddingBottomMobile || hasTag(item && item.tags, 'Columns.AddBottomPaddingMobile')

  // For a column to be flush to top, that column must have the noPaddingTop tag
  const firstColumnComponent = children[0]?.props.item
  const firstColumnIsFlush = hasTag(firstColumnComponent?.tags, 'Columns.NoTopPadding') || noTopPadding
  const firstColumnIsFlushMobile = hasTag(firstColumnComponent?.tags, 'Columns.NoTopPaddingMobile') || noTopPaddingMobile

  const secondColumnComponent = children[1]?.props.item
  const secondColumnIsFlush = hasTag(secondColumnComponent?.tags, 'Columns.NoTopPadding') || noTopPadding
  const secondColumnIsFlushMobile = hasTag(secondColumnComponent?.tags, 'Columns.NoTopPaddingMobile') || noTopPaddingMobile

  return (
    <ThemeProvider theme={{ ...theme, direction: 'ltr' }}>
      <Grid.Row verticallyCenter={alignVertically}>
        <Grid.Span small={left.small} medium={left.medium}>
          <SpanContainer
            noPaddingTop={firstColumnIsFlush}
            noPaddingTopMobile={firstColumnIsFlushMobile}
            addPaddingBottom={addBottomPadding}
            addPaddingBottomMobile={addBottomPaddingMobile}
          >
            <ThemeProvider theme={theme}>
              {children[0]}
            </ThemeProvider>
          </SpanContainer>
        </Grid.Span>
        <Grid.Span small={right.small} medium={right.medium}>
          <SpanContainer
            noPaddingTop={secondColumnIsFlush}
            noPaddingTopMobile={secondColumnIsFlushMobile}
            addPaddingBottom={addBottomPadding}
            addPaddingBottomMobile={addBottomPaddingMobile}
          >
            <ThemeProvider theme={theme}>
              {children[1]}
            </ThemeProvider>
          </SpanContainer>
        </Grid.Span>
      </Grid.Row>
    </ThemeProvider>
  )
}

TwoColumnWithRatio.propTypes = {
  children: array,
  item: object,
  verticallyCenter: bool
}

TwoColumnWithRatio.defaultProps = {
  children: [],
  item: {},
  verticallyCenter: false
}

TwoColumnWithRatio.layoutVariant = [
  'isc-two-column-ratio-7-5',
  'isc-two-column-ratio-4-8',
  'isc-two-column-ratio-8-4',
  'isc-two-column-ratio-3-9',
  'isc-two-column-ratio-9-3'
]

export default withTheme(TwoColumnWithRatio)
